<template>
  <transition name="fade">
    <div class="b-modal b-modal--blur">
      <div class="b-modal__inner b-firstentry">
        <div class="b-modal__title">{{ $t('core.dashboard.first_entry.title') }}</div>
        <div
          class="b-modal__info"
          v-html="
            $t('core.dashboard.first_entry.text', {
              value: get_amount,
              currency: get_currency
            })
          "
        ></div>
        <div class="b-modal__button">
          <i-button type="primary" @click="start_using"> {{ $t('core.dashboard.first_entry.start') }}</i-button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    computed: {
      get_currency() {
        return this.$user.currency;
      },
      get_amount() {
        /* eslint-disable no-unreachable, vue/script-indent */
        switch (this.$user.currency) {
        case 'RUB': {
          return '20';
        }
        case 'USD': {
          return '5';
        }
        case 'EUR': {
          return '5';
        }
        case 'IDR': {
          return '70000';
        }
        case 'VND': {
          return '100000';
        }
        case 'KZT': {
          return '150';
        }
        case 'INR': {
          return '30';
        }
        default: {
          return '';
        }
        }
        /* eslint-enable */
      }
    },
    methods: {
      start_using() {
        localStorage.removeItem('firstEntry');
        localStorage.removeItem('userKey');
        this.$emit('close_first_entry');
      }
    }
  };
</script>

<style lang="scss">
  .b-modal {
    background-color: rgba(52, 63, 75, 0.6);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;

    &--blur {
      backdrop-filter: blur(5px);
    }

    &__inner {
      &.b-firstentry {
        // border-radius: 6px;
        background: initial;
        // background-size: 10%;
        width: 550px;
        padding: 30px 26px 15px 70px;
        font-family: 'Lato', 'sans-serif';
        text-align: center;
        margin: 245px auto auto;
        color: #fff;
      }
    }

    &__title {
      font-size: 32px;
      font-weight: 700;
      line-height: 29px;
    }

    &__info {
      font-size: 18px;
      font-weight: 300;
      line-height: 22px;
      margin-top: 20px;
      color: #fff;
      b {
        font-weight: 400;
      }
    }

    &__button {
      margin-top: 20px;

      button {
        padding: 0 22px;
        color: #fff;
        height: 40px;
        font-size: 14px;
        text-transform: uppercase;
      }
    }
  }
</style>
